import { FormattedMessage, FormattedNumber } from 'react-intl';

export interface InvestorsCountProps {
  investorsCount: number;
}

export const InvestorsCount = ({ investorsCount }: InvestorsCountProps) => (
  <FormattedMessage id="common.investor.count" values={{ count: <FormattedNumber value={investorsCount} /> }} />
);
